import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { decode } from 'jsonwebtoken';
import {
  ACCOUNT_TYPES,
  APPLICATION_TYPE_STRING,
  CorporateAccountType,
  REGISTRATION_FLOW_TYPES,
} from '../util/constants';
import { corporateAccountMenu } from '../constants/menus/corporateAccountMenu';
import { individualAccountMenu } from '../constants/menus/individualAccountMenu';
import { retirementPersonalAccountMenu } from '../constants/menus/retirementPersonalAccountMenu';
import { jointAccountMenu } from '../constants/menus/jointAccountMenu';
import { utmaAccountMenu } from '../constants/menus/utmaAccountMenu';
import { applicationTypeStringHelper } from '../util/helpers/applicationTypeStringHelper';
import {
  removeFromSessionStorage,
  retrieveFromSessionStorage,
  storeInSessionStorage,
} from '../util/helpers/sessionStorageHelper';
import {
  APPLICATION_TYPE,
  ACCOUNT_TYPE,
  REGISTRATION_FLOW_TYPE,
} from '../constants/sessionStorage';
import { trustAccountMenu } from '../constants/menus/trustAccountMenu';
import { selectApplication } from '../store/selectors/applicationSelectors';
import { metalStreamMenu } from '../constants/menus/metalStreamMenu';
import { JWT_TOKEN } from '../constants/localStorage';
import { PAGES } from '../constants/pages';
import { applicationStepRedirectionHelper } from '../util/helpers/applicationStepHelper';
import LoadingMessage from '../components/LoadingMessage';
import { createApplication } from '../store/actions/application/applicationActions';
import { getTokens } from '../util/helpers/getTokensHelper';
import { refreshTokens } from '../store/actions/user/userActions';
import useChoosenApplicationTypeData from '../hooks/useChoosenApplicationTypeData';
import { selectSettings } from '../store/selectors/settingsSelectors';

const LoadingPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const Application = useSelector(selectApplication);
  let { BrokerCode } = useSelector(selectSettings);

  // Fix for issue with BrokerCode on backend for GBI Direct
  if (BrokerCode === 'GBI-PORTAL') {
    BrokerCode = 'GBID';
  }

  const registrationFlowType = retrieveFromSessionStorage(
    REGISTRATION_FLOW_TYPE,
  );
  const accountType = retrieveFromSessionStorage(ACCOUNT_TYPE);

  const { JwtToken, JwtRefreshToken } = getTokens();
  const { data } = useChoosenApplicationTypeData();
  const applicationTypeFromRequest =
    history.location?.state?.application?.ApplicationType;
  const startNewApplication = () => {
    const onSuccess = () => {
      dispatch(
        refreshTokens({
          data: {
            JwtToken,
            JwtRefreshToken,
          },
          onSuccess: () => {
            history.push(redirectTo('IndividualApplication'));
            document.body.style.overflow = 'unset';
          },
        }),
      );
    };
    const { ApplicationUid } = decode(JwtToken);
    const params = {
      registrationFlowType: REGISTRATION_FLOW_TYPES.AIP,
    };
    dispatch(
      createApplication({
        data,
        onSuccess,
        ApplicationUid,
        params,
      }),
    );
  };
  const redirectTo = (applicationType, accountType) => {
    if (
      Application.RegistrationFlowType === 2 ||
      registrationFlowType === REGISTRATION_FLOW_TYPES.AIP
    ) {
      return metalStreamMenu[1].path;
    }

    if (accountType === CorporateAccountType[4]) {
      return trustAccountMenu[1].path;
    }

    switch (applicationType) {
      case APPLICATION_TYPE_STRING[1]:
        return individualAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[2]:
        return corporateAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[3]:
        return retirementPersonalAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[4]:
        return jointAccountMenu[1].path;

      case APPLICATION_TYPE_STRING[5]:
        return utmaAccountMenu[1].path;

      default:
        break;
    }
  };

  useEffect(() => {
    const JwtToken = retrieveFromSessionStorage(JWT_TOKEN);

    if (!JwtToken) {
      if (
        retrieveFromSessionStorage(REGISTRATION_FLOW_TYPE) ===
        REGISTRATION_FLOW_TYPES.AIP
      ) {
        history.replace(PAGES.AIP);
      } else {
        history.replace(PAGES.BASE);
      }
    }

    if (isEmpty(Application)) {
      return;
    }

    const { ApplicationType } = Application;
    const applicationType = ApplicationType ?? applicationTypeFromRequest;

    if (!applicationType) {
      const registrationFlowType = retrieveFromSessionStorage(
        REGISTRATION_FLOW_TYPE,
      );
      if (registrationFlowType === 'Aip') {
        startNewApplication();
        return;
      }
      history.push(PAGES.CHOOSE_APPLICATION.MAIN);
    }

    if (applicationStepRedirectionHelper(Application)) {
      return;
    }

    if (applicationType) {
      removeFromSessionStorage(APPLICATION_TYPE);
      // removeFromSessionStorage(ACCOUNT_TYPE);
      // Check if this affects on something

      if (applicationType) {
        const applicationTypeString = applicationTypeStringHelper(
          applicationType,
        );

        if (applicationTypeString) {
          if (applicationTypeString === 'undefinedApplication') return;

          storeInSessionStorage(APPLICATION_TYPE, applicationTypeString);
          const accountData = Application[applicationTypeString];

          if (
            (accountData || accountType) &&
            applicationTypeString &&
            (accountData?.AccountType || accountType)
          ) {
            const accountTypeString = accountData?.AccountType
              ? ACCOUNT_TYPES[applicationTypeString][accountData?.AccountType]
              : accountType;

            if (accountTypeString) {
              storeInSessionStorage(ACCOUNT_TYPE, accountTypeString);
              history.push(
                redirectTo(applicationTypeString, accountTypeString),
              );
              return;
            }
          }

          history.push(redirectTo(applicationTypeString));
          return;
        }
      }

      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    Application,
    Application?.ApplicationType,
    applicationTypeFromRequest,
    accountType,
    history,
  ]);

  return <LoadingMessage BrokerCode={BrokerCode} />;
};

export default LoadingPage;
